export default "__VITE_ASSET__r7qt4A2r__"